import DayColaLogo from "../assets/playground/DayColaLogo.svg";
import NightColaLogo from "../assets/playground/NightColaLogo.svg";

import { getDayPeriod } from "../utils/dayNight";


interface AvatarStackProps {
  firstName?: string;
  lastName?: string;
  avatarUrl?: string | null;
  ideacard?: boolean;
}


const getInitials = (
  firstName?: string,
  lastName?: string,
  fallback = "",
): string =>
  `${firstName?.[0] ?? ""}${lastName?.[0] ?? ""}`
    .trim()
    .toUpperCase() || fallback;

const AvatarStack = ({
  firstName,
  lastName,
  avatarUrl,
  ideacard,
}: AvatarStackProps) => {
  const initials = getInitials(firstName, lastName);

  return (
    <div className="inline-flex">
      <div className={`${ideacard ? "size-14" : "size-10"} relative z-20 rounded-[100px] shrink-0 border-2 shadow-[0_8px_24px_rgba(0,0,0,0.18)] ,
        ${(getDayPeriod() === "day" || ideacard) ? "border-white bg-white" : "border-[#000] bg-[#000]"}`}>
        {avatarUrl ? (
          <img
            src={avatarUrl}
            alt={
              firstName && lastName ? `${firstName} ${lastName}` : "User avatar"
            }
            className="h-full w-full rounded-[100px] object-cover"
          />
        ) : (
          
          <div className={`flex h-full w-full items-center justify-center px-2 pt-[7px] pb-[9px] rounded-[100px] bg-[#ABE6FF] subtitle-l uppercase ${ideacard ? "hidden" : ""}`}>
            {initials}
          </div>
        )}
        <span className={`absolute right-[-5px] top-[-4px] h-4 w-4 rounded-full border-2 bg-[#16c46f] shadow-[0_2px_6px_rgba(0,0,0,0.18)] ${getDayPeriod() === "day" ? "border-white " : "border-[#000]"} ${ideacard ? "hidden" : ""}`} />
      </div>

      <div className={`size-10 relative rounded-[100px] z-10 outline-offset-[-2px] -ml-3 flex shrink-0 items-center justify-center ${ideacard ? "hidden" : ""}`}>
        <img
          src={getDayPeriod() === "day" ? DayColaLogo : NightColaLogo}
          alt="Coca-Cola avatar"
          className={`h-full w-full object-contain rounded-[100px] border-2 ${getDayPeriod() === "day" ? "border-white " : "border-[#000]"} `}
        />
      </div>
    </div>
  );
};

export default AvatarStack;
